import React, { useEffect, useState } from "react";
import AHeader from "../component/AHeader";
import AFooter from "../component/AFooter";
import axios from "axios";
import { toast } from "react-toastify";

function Appointmet_Mange() {
  useEffect(() => {
    fetch();
    document.getElementById('spinner').style.display = "none";
    fetch1();
    document.getElementById('spinner1').style.display = "none";
  });

  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/appointment_single_get_pending`
    );
    console.log(res.data);
    setData(res.data);
  };

  const [data1, setData1] = useState([]);
  const fetch1 = async () => {
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/appointment_single_get_approved`
    );
    console.log(res.data);
    setData1(res.data);
  };

  const deletehandle = async (id) => {
    const res = await axios.delete(`https://www.rajvicosmeticclinic.com/RajviApi/appointment_delete?id=${id}`);
    console.log(res.data);
    fetch();
    toast.success("Appointment Deleted Success");
  };

  const statushandel = async (id) => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/appointment_status?id=${id}`);
    toast.success('Status update success');
    fetch();
  };

  return (
    <div>
      <AHeader title="Manage Appointment" />
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className=" col-lg-12 ">
              <div className="bg-light  p-lg-5">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Appointment
                </h6>
                <h1 className="mb-4">Manage Pending Appointment</h1>
                <div className='justify-content-center text-center mb-5' id='spinner'>
                  <div class="spinner-border text-danger mt-5"></div>
                </div>

                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th>ID</th>
                      <th>User Id</th>
                      <th>App_Date</th>
                      <th>service_id</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(data.length > 0) ? data && data.map((value, index) => {
                      return (
                        <tr>
                          <td>{value.id}</td>
                          <td>{value.userid}</td>
                          <td>{value.app_Date}</td>
                          <td>{value.service_id}</td>
                          <td>{value.status}</td>
                          <td>
                            <button
                              className="btn btn-danger mr-3"
                              onClick={() => deletehandle(value.id)}
                            >
                              Delete
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={() => statushandel(value.id)}
                            >
                              {value.status}
                            </button>
                          </td>
                        </tr>
                      );
                    }) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className=" col-lg-12 ">
              <div className="bg-light  p-lg-5">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Appointment
                </h6>
                <h1 className="mb-4">Approved Appointment</h1>
                <div className='justify-content-center text-center mb-5' id='spinner1'>
                  <div class="spinner-border text-danger mt-5"></div>
                </div>

                <table className="table">
                  <thead className="table-dark">
                    <tr>
                      <th>ID</th>
                      <th>User Id</th>
                      <th>App_Date</th>
                      <th>service_id</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>

                    {(data1.length > 0) ? data1 && data1.map((value) => {
                      return (
                        <tr>
                          <td>{value.id}</td>
                          <td>{value.userid}</td>
                          <td>{value.app_Date}</td>
                          <td>{value.service_id}</td>
                          <td>{value.status}</td>
                          <td>
                            <button
                              className="btn btn-danger mr-3"
                              onClick={() => deletehandle(value.id)}
                            >
                              Delete
                            </button>
                            <button
                              className="btn btn-success"
                              onClick={() => statushandel(value.id)}
                            >
                              {value.status}
                            </button>
                          </td>
                        </tr>
                      )
                    }) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AFooter />
    </div>
  );
}

export default Appointmet_Mange;
